import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, ListItem, ListItemText, palette, } from '@kareo/design-system';
import featureToggles from '../../../lib/sdk/featureToggles'; // can't use "shared-assets" as it's not recognised in legacy app
import PatientMessagesNavItem from './PatientMessagesNavItem';
import { StyledNavList } from '../../utils/styledFacesheet';
import useChartNavbarLinks from '../../hooks/useChartNavbarLinks';
import { FEATURE_FLAG_TO_SHOW_MESSAGES_IN_FACESHEET } from '../../constants';
var FacesheetNavBar = function (_a) {
    var links = _a.links, patientId = _a.patientId;
    var _b = useChartNavbarLinks(links, patientId), loading = _b.loading, navbarLinks = _b.navbarLinks;
    var linksToDisplay = links || navbarLinks;
    var _c = useState(false), hasAccessToMessages = _c[0], setHasAccessToMessages = _c[1];
    useEffect(function () {
        // only show the messages nav item if the feature toggle is enabled
        featureToggles
            .isEnabled(FEATURE_FLAG_TO_SHOW_MESSAGES_IN_FACESHEET)
            .then(function (featureToggleEnabled) {
            setHasAccessToMessages(featureToggleEnabled);
        });
    }, []);
    return (React.createElement(Box, { component: "div", width: "100%", minWidth: "10rem", bgcolor: palette.background.paper, border: 1, borderColor: "background.default", marginTop: "-1px" },
        React.createElement(StyledNavList, { "aria-label": "patient navbar list" },
            loading ? (React.createElement(Box, null,
                React.createElement(CircularProgress, null))) : (linksToDisplay &&
                linksToDisplay.map(function (link) { return (React.createElement(ListItem, { component: "a", key: link.linkName, href: link.url.replace('{patientId}', String(patientId)) },
                    React.createElement(ListItemText, { primary: link.displayName }))); })),
            hasAccessToMessages && (React.createElement(PatientMessagesNavItem, { patientId: patientId })))));
};
export default FacesheetNavBar;
